import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { environments } from "../config";
import { tokenStore } from "@/stores/tokenStore";

const httpLink = createHttpLink({
  uri: `${environments.graphApiUrl}`,
});

const authLink = setContext((_, { headers }) => {
 const { token } = tokenStore.getState();
  return {
    headers: {
      ...headers,
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  };
});

const client = new ApolloClient({
  ssrMode: typeof window === "undefined",
  link: authLink.concat(httpLink),

  cache: new InMemoryCache(),
});

export default client;
